import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-reset-account-password',
  templateUrl: './reset-account-password.component.html',
  styleUrls: ['./reset-account-password.component.scss'],
})
export class ResetAccountPasswordComponent implements OnInit {
  inputForm: FormGroup;

  constructor() {}

  ngOnInit() {
    this.inputForm.addControl(
      'password',
      new FormControl('', [Validators.required])
    );
    this.inputForm.addControl(
      'password_repeat',
      new FormControl('', [
        Validators.required,
        control => {
          if (!this.inputForm.get('password').value) {
            return {
              passwordNotPatch: true,
            };
          }

          if (control.value !== this.inputForm.get('password').value) {
            return {
              passwordNotPatch: true,
            };
          }

          return null;
        },
      ])
    );
  }

  get passwordRepeat(): AbstractControl {
    return this.inputForm.get('password_repeat');
  }
}
